export const ACADEMY_NAME = "Uday Career Academy";
export const ACADEMY_NAME_FULL = "Uday Career Academy & Library, Dindori";
export const ACADEMY_TAGLINE = "Police & Army Bharti Special";
export const ACADEMY_MOTTO = "सिद्धिर्भवति कर्मजा";
export const ACADEMY_ADDRESS = "पहिला मजला, पटवा कॉम्प्लेक्स, दिंडोरी बस स्टँड समोर, दिंडोरी, नाशिक 422202";
export const ACADEMY_PHONE = "9767767618";
export const LOGO_URL = "/logo.jpg";
